export const SiteDetailsValidationError = {
  '23030402': 'siteDetails.validationError.workInterval.overlap',
  '25030602': 'siteDetails.validationError.workInterval.overlap',
};
